import React from 'react';
import { Carousel, AnalyticsAttributesProvider } from '../../components';
import { UiBlock } from '../UiBlock';
import { UiQuote } from '../UiQuote';
import { UiStack } from '../UiStack';
import { ShadowWrapper } from './UiCarousel.styles';
export default function UiCarousel({ model }) {
    const { blocks, arrows, dots, title } = model.content;
    return (React.createElement(AnalyticsAttributesProvider, { value: { eventColumn: title, eventComponent: model.type } },
        React.createElement(Carousel, { arrows: arrows, dotsOnDesktop: dots, dotsOnMobile: true }, blocks === null || blocks === void 0 ? void 0 : blocks.map((block) => {
            switch (block.type) {
                case 'uiBlock':
                    //so shadows won't be hidden by carousel's overflow-hidden
                    return block.content.shadow ? (React.createElement(ShadowWrapper, { key: block.id },
                        React.createElement(UiBlock, { model: block }))) : (React.createElement(UiBlock, { key: block.id, model: block }));
                case 'uiQuote':
                    return React.createElement(UiQuote, { key: block.id, model: block });
                case 'uiStack':
                    return React.createElement(UiStack, { key: block.id, model: block });
            }
        }))));
}
//# sourceMappingURL=UiCarousel.js.map